function getActivePage(){
    let arr = (window.location.href).split('/');
    let index = arr[arr.length-1] ==="" ? 2:1;
    let activePage = arr[arr.length-index];
    return activePage
}

export default getActivePage;

